export default __webpack_public_path__ + "static/media/549.7c2f48f3.gif";